import React from 'react';
import { useSelector } from 'react-redux';
import {
  getAccountsTo,
  getFrequency,
  getStartDate,
  getContributionPerAccount,
  getTotalContributionPerPeriod,
} from '../../../redux/modules/funds/IRAAutoMaxCalculation/IRAAutoMaxCalculations.selectors';
import { getSelectedBank } from 'src/redux/modules/bankSelection/bankSelection.selectors';
import './IRAAutoMaxReview.scss';
import numeral from 'numeral';
import Checkbox from '../../Shared/Checkbox/Checkbox';
import { IRA_AUTO_MAX_CONTRIBUTIONS_MODAL } from '../../../redux/modules/modals/modals.module';
import ModalLink from '../../Shared/Modal/ModalLink/ModalLink';
import TRP from '../../Shared/TRP/TRP';

/**
 * @todo put into util prior to merge
 * @param {number} amt
 * @returns
 */
const fmtCurrency = (amt) => numeral(amt).format('$0,0.00');

export const IRAAutoMaxReview = ({ toggleTerms, userAgrees }) => {
  const selectedBank = useSelector(getSelectedBank);
  const accountsTo = useSelector(getAccountsTo);
  const frequency = useSelector(getFrequency);
  const startDate = useSelector(getStartDate);
  const totalContribution = useSelector(getTotalContributionPerPeriod);
  const contributionPerAccount = useSelector(getContributionPerAccount);
  return (
    <div className="ira-automax-review-container">
      <div className="ira-automax-review-header-row">
        <div className="ira-automax-review-from-col">
          <div className="col-label">From:</div>
          <div className="value-cell">
            <div className="selected-bank-display blocked_data">
              {selectedBank.name} &mdash;
              <br /> {selectedBank.bankAccountType} {selectedBank.accountNumber}
            </div>
          </div>
        </div>
        <div className="ira-automax-review-to-col">
          <div className="col-label">To: </div>
          {accountsTo.map((acc) => (
            <div className="value-cell" key={acc.agreementNumber}>
              <div className="account-type">{acc.accountType}</div>
              <div className="fund-name">{acc.fundName}</div>
              <div className="ticker">{acc.ticker}</div>
              <div className="agreement-number-name blocked_data">
                {acc.agreementNumber} • {acc.name}
              </div>
            </div>
          ))}
        </div>
        <div className="ira-automax-review-frequency-col">
          <div className="col-label">Frequency</div>
          <div className="value-cell">
            <span className="frequency-text">{frequency}</span>
          </div>
        </div>
        <div className="ira-automax-review-start-date-col">
          <div>
            <div className="col-label">Est. Start Date </div>
            <div className="value-cell">
              <span className="start-date-text">{startDate}</span>
            </div>
          </div>
        </div>
        <div className="ira-automax-contribution-per-col">
          <div className="col-label">Contribution Per Account:</div>
          <div>
            {accountsTo.map((i) => (
              <div key={i.amount} className="value-cell_contribution-amount">
                <span className="contribution-per-account-text">
                  {fmtCurrency(contributionPerAccount)}*
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="ira-automax-review-transaction-review-row">
        <div className="totals-container">
          <div className="total-contribution-label">
            Total Contribution Per Period
          </div>
          <div className="total-contribution-value">
            {fmtCurrency(totalContribution)}
          </div>
        </div>
      </div>
      <div className="review-disclaimer">
        *All amounts are estimates for the current year and may change the
        following year based on occurrence and total allowed contribution at
        that time. Click{' '}
        <ModalLink
          link="here"
          linkStyle={'dashed'}
          modalName={IRA_AUTO_MAX_CONTRIBUTIONS_MODAL}
        />{' '}
        to view a comprehensive schedule.
      </div>

      <div className="customer-instruction">
        <h3>IRA AutoMax Customer Agreement</h3>
        <p>
          To enroll in the IRA AutoMax service, you must agree to the following
          terms and conditions.
        </p>

        <p>By selecting “I Agree” below, :</p>
        <ul className="customer-review-agreement-container">
          <li>
            <p>
              I authorize <TRP /> Services, Inc. (“
              <TRP />
              ”) to increase/decrease my periodic IRA contribution amounts in
              future years, to the extent necessary so that I will contribute
              the maximum amount permitted by the IRS for the applicable tax
              year based on my date of birth.
            </p>
          </li>
          <li>
            <p>
              I acknowledge that I am solely responsible for determining my
              eligibility to contribute to an IRA for each tax year, and for
              calculating the amount I am eligible to contribute for each tax
              year, in compliance the Internal Revenue Code. <TRP /> shall have
              no obligation to verify my eligibility to contribute, the
              deductibility of any contribution, or tax effect of any
              contribution made to the IRA(s). I will contact <TRP />{' '}
              immediately to amend or cancel the IRA AutoMax service if my
              personal circumstances change in the future in a manner that would
              limit or eliminate my eligibility to contribute to an IRA in any
              given year.
            </p>
          </li>
          <li>
            <p>
              My authorization of these terms, including any credit or debit
              entries initiated there under, is in full force and effect until I
              notify <TRP /> of its revocation and <TRP /> has sufficient time
              to act on it.
            </p>
          </li>
          <li>
            <p>
              I indemnify and hold harmless <TRP />, its affiliates, successors,
              and employees from any and all liability as a result of my
              enrollment in the IRA AutoMax service, including but not limited
              to penalties assessed against me by the IRS as a result of
              contributions made to any and all IRAs in excess of the amount
              permitted by the Internal Revenue Code.
            </p>
          </li>
        </ul>
        <p>Please select “I Agree” to continue.</p>
        <div className="agree-check">
          <Checkbox
            checked={userAgrees}
            onChange={toggleTerms}
            id="i-agree-checkbox"
          />
          <label htmlFor="i-agree-checkbox">
            <span>I Agree</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default IRAAutoMaxReview;
